<template>

  <div id="categoriesSidebar" :class="[isMobile ? 'categories__mobile' : 'categories', 'shadow-xl', 'large:shadow-none']">
    <div class="categories__mobile-header">
      <h3 class="categories__mobile-title">
        Preču kategorijas
      </h3>
      <button class="modal__close" data-close-categories type="button">
        <img alt="" src="/shop/images/modal-close.svg">
      </button>
    </div>
    <ul class="categories__list">
      <li v-for="category in displayedCategories" :key="category.id" class="categories__item">
        <a :href="category.link" :title="category.title" class="categories__link">
          <picture>
            <source :srcset="category.images.category_icon.webp" type="image/webp">
            <img :src="category.images.category_icon.source" alt="" class="categories__icon" height="24" width="24">
          </picture>
          {{ category.title }}
        </a>
      </li>
    </ul>
  </div><!-- /.categories -->
</template>

<script>
export default {
  name:  "CategoryList",
  props: {
    'in18': Object,
    'root_categories': Object,
    'isMobile': {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      displayedCategories: this.root_categories,
    };
  },
  methods: {
    showAllCategories() {
      this.displayedCategories = this.root_categories;
    },
  },
}
</script>
